import { render, staticRenderFns } from "./what-where.vue?vue&type=template&id=6c88ef20&scoped=true&"
import script from "./what-where.vue?vue&type=script&lang=js&"
export * from "./what-where.vue?vue&type=script&lang=js&"
import style0 from "./what-where.vue?vue&type=style&index=0&id=6c88ef20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c88ef20",
  null
  
)

export default component.exports